import React from 'react';
import * as GridTitle from '../../../constants/K007/GridTitle';

class MainGridTopLeftDayOn extends React.Component {
  render() {
    return (
      <div className="ledger_sheet_fixed fixed_left ib vt bar bar_x_hidden bar_y_hidden">
        <div className="modlue left_col">
          <div className="rowh sheet_header">
            <div className="col1 no_context ib col_koumoku_number no_extend except_highlight">
              <p className="nh no-padding">{GridTitle.GRID_TITLE_LEFT[0].name}</p>
            </div>
            <div className="col1 no_context ib col_kishu no_extend except_highlight">
              <p className="nh">{GridTitle.GRID_TITLE_LEFT[1].name}</p>
            </div>
            <div className="col ib col_day no_extend except_highlight">
              <p className="nh">平日・休日</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MainGridTopLeftDayOn;
